import {
  formatEventName,
  formatPropertyNames,
  getEventContext,
} from './helpers';
import merge from 'lodash/merge';

const MIDDLEWARE = new Map([
  [
    'identify',
    (event, supplementalContextHelpers) => {
      if (!event.traits) {
        return;
      }

      supplementalContextHelpers?.setSupplementalContext((prevValue) => ({
        ...prevValue,
        user_traits: merge(prevValue?.user_traits, event.traits),
      }));
    },
  ],
  [
    'page',
    (event, supplementalContextHelpers) => {
      event.context = getEventContext(event, supplementalContextHelpers);
    },
  ],
  [
    'track',
    (event, supplementalContextHelpers) => {
      event.name = formatEventName(event.name);
      event.properties = formatPropertyNames(event.properties);
      event.context = getEventContext(event, supplementalContextHelpers);
    },
  ],
]);

/**
 * Apply middleware to the passed in analytics instance.
 *
 * @see https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/middleware/
 */
function applyMiddleware(analytics, supplementalContextHelpers) {
  analytics.addSourceMiddleware(({ payload, next }) => {
    const event = payload.obj;

    MIDDLEWARE.get(event.type)?.(event, supplementalContextHelpers);

    next(payload);
  });
}

export default applyMiddleware;
